// import React, { useState, useRef, useEffect } from "react";
// import "./selectedvalues.css";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SelectDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   disabled = false, // added prop
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState(""); // Track selected label for display
//   const dropdownRef = useRef(null);

//   // Update displayed label when the `selected` prop changes
//   useEffect(() => {
//     const selectedOption = options.find((option) => option.id === selected);
//     setSelectedLabel(selectedOption ? selectedOption.label : "");
//   }, [selected, options]);

//   // Close the dropdown when clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Handle dropdown item click
//   const handleClick = (option) => {
//     if (disabled) return; // ignore clicks when disabled
//     setSelected(option.id); // Update the selected value in parent
//     setIsActive(false); // Close the dropdown
//     setSelectedLabel(option.label); // Update displayed label
//   };

//   const toggleActive = () => {
//     if (disabled) return;
//     setIsActive((prev) => !prev);
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{
//         width,
//         marginLeft,
//         marginTop,
//         // opacity: disabled ? 0.6 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//       }}
//       ref={dropdownRef}
//       aria-disabled={disabled}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         onClick={toggleActive}
//         style={{
//           // backgroundColor: disabled ? "#f5f5f5" : "white",
//           opacity: disabled ? 0.6 : 1,
//           cursor: disabled ? "not-allowed" : "pointer",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           paddingRight: "8px",
//         }}
//       >
//         <span style={{ color: selectedLabel ? "#6A6A6A" : "#aaa" }}>
//           {selectedLabel || placeholder}
//         </span>
//         <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//           <img src={DropDownIcon} alt="dropdown-icon" />
//         </div>
//       </div>
//       {isActive && !disabled && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className={`dropdown-item ${option.id === selected ? "selected" : ""}`}
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import "./selectedvalues.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function SelectDropdown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  disabled = false,
  showError = false,  // ← NEW
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  // Update displayed label when the `selected` prop changes
  useEffect(() => {
    const selectedOption = options.find((option) => option.id === selected);
    setSelectedLabel(selectedOption ? selectedOption.label : "");
  }, [selected, options]);

  // Close the dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle dropdown item click
  const handleClick = (option) => {
    if (disabled) return;
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  // ── NEW: clear selection — only allowed when !isRequired ──────────────────
  const handleClear = (e) => {
    e.stopPropagation();
    if (isRequired) return; // safety guard
    setSelected(null);
    setSelectedLabel("");
  };
  // ──────────────────────────────────────────────────────────────────────────

  const toggleActive = () => {
    if (disabled) return;
    setIsActive((prev) => !prev);
  };

  // ── NEW: error state — red border when required and nothing selected ───────
  const hasError = showError && isRequired && !selected && !selectedLabel;
  // ──────────────────────────────────────────────────────────────────────────

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
      aria-disabled={disabled}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className={`dropdown-btn ${hasError ? "dropdown-error" : ""}`}  // ← NEW
        onClick={toggleActive}
        style={{
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "8px",
          border: hasError ? "1px solid #ff0000" : undefined,  // ← NEW
        }}
      >
        <span style={{ color: selectedLabel ? "#6A6A6A" : "#aaa" }}>
          {selectedLabel || placeholder}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {/* ── NEW: cross shows only when value selected AND !isRequired ──── */}
          {selectedLabel && !isRequired && (
            <span
              style={{
                cursor: "pointer",
                color: "#aaa",
                fontSize: "16px",
                marginRight: "30px",
                userSelect: "none",
              }}
              onClick={handleClear}
            >
              ×
            </span>
          )}
          {/* ─────────────────────────────────────────────────────────────── */}
          <img src={DropDownIcon} alt="dropdown-icon" />
        </div>
      </div>
      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className={`dropdown-item ${option.id === selected ? "selected" : ""}`}
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}